import { connect } from 'react-redux';

const AccessControl = ({
  permissions,
  allowedPermissions,
  matchAll,
  children,
  renderNoAccess,
}) => {
  const permitted = AccessControl.hasPermission(permissions, allowedPermissions, matchAll);

  if (permitted) {
    return children;
  }
  if (renderNoAccess) {
    return renderNoAccess();
  }
  return null;
};

AccessControl.defaultProps = {
  allowedPermissions: [],
  permissions: [],
  matchAll: false,
  renderNoAccess: () => null,
};

AccessControl.hasPermission = function (permissions, allowedPermissions, matchAll = false) {
  if (!permissions || permissions.length === 0
    || !allowedPermissions || allowedPermissions.length === 0) {
    return false;
  }

  if (matchAll === true) {
    return allowedPermissions.every(permission => permissions.includes(permission));
  }

  return permissions.some(permission => allowedPermissions.includes(permission));
};

// Compose AccessControl component with redux
function mapStateToProps(state) {
  const {
    auth: {
      permissions
    }
  } = state;

  return {
    permissions,
  };
}

export default connect(
  mapStateToProps
)(AccessControl);
